// src/pages/suppliers/Suppliers.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import SuppliersTable from "../../components/suppliers/SuppliersTable";

const Suppliers = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <SuppliersTable />
        </WrapperSection>
    );
};

export default Suppliers;
